import React, { useEffect, useState } from "react";
import ManifestSelectModal from "../components/ManifestSelectModal";
import { toast } from "react-toastify";
import { getManifests } from "../services/manifestService";
import TripSheetForm from "../components/TripSheetForm";
import { useSelector } from "react-redux";
import { createTripSheet } from "../services/tripSheetService";

const TripSheet = () => {
  const { user } = useSelector((state) => state.user);
  // const [shipments, setShipments] = useState([]);
  // const [isModalOpen, setIsModalOpen] = useState(false);
  // const [selectedManifests, setSelectedManifests] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [tripSheet, setTripSheet] = useState({
    tripSheetNo: "",
    vendorType: "",
    tripDate: "",
    tripTime: "",
    routeName: "",
    tripHireContact: "",
    vehicleModel: "",
    vehicleNumber: "",
    vendorName: "",
    driverName: "",
    mobileNumber: "",
    licenseNumber: "",
    manifests: [],
    startKm: "",
    endKm: "",
    totalKmDriven: "",
    fuel1: "",
    fuel2: "",
    totalTollsPaid: "",
    unloadingCharges: "",
    otherExpenses: "",
    perKgExpenses: "",
    totalExpenses: "",
    totalPackages: "",
    totalWeight: "",
  });
  const handleClear = () => {
    setTripSheet({
      tripSheetNo: "",
      vendorType: "",
      tripHireContact: "",
      tripDate: "",
      startKm: "",
      endKm: "",
      totalPackages: "",
      totalWeight: "",
      tripTime: "",
      routeName: "",
      vehicleModel: "",
      vehicleNumber: "",
      vendorName: "",
      driverName: "",
      mobileNumber: "",
      licenseNumber: "",
      manifests: [],
      totalKmDriven: "",
      fuel1: "",
      fuel2: "",
      totalTollsPaid: "",
      unloadingCharges: "",
      otherExpenses: "",
      perKgExpenses: "",
      totalExpenses: "",
    });
  };
  /* ---------- Handlers ---------- */

  // const handleGetManifestData = async () => {
  //   try {
  //     const res = await getManifests();
  //     if (res?.status === 200) {
  //       setManifestData(res?.data);
  //     } else {
  //       toast.error("Failed to get manifest data. Please try again.");
  //     }
  //   } catch (error) {
  //     console.log("Failed to get manifest data", error);
  //     toast.error("Failed to get manifest data. Please try again.");
  //   }
  // };
  const handleSaveTripSheet = async () => {
    try {
      if (!user?.branch?.id && !user?.branch?.code) {
        toast.error("User branch information is missing.");
        return;
      }
      if (!tripSheet?.routeName || !tripSheet?.tripSheetNo) {
        toast.error("Route name and Trip sheet number are required.");
        return;
      }
      const now = new Date();

      setIsLoading(true);
      const payload = {
        ...tripSheet,
        branchID: user?.branch?.id,
        branchCode: user?.branch?.code,
        tripDate: now.toISOString().split("T")[0],
        tripTime: now.toTimeString().split(" ")[0],
      };
      const res = await createTripSheet(payload);
      if (res?.status === 200 || res?.status === 201) {
        toast.success("TripSheet saved successfully!");
        handleClear();
        console.log("TripSHeet saved:");
      }
    } catch (error) {
      toast.error(error?.response?.data?.error);

      console.log("Failed to save trip sheet", error);
    } finally {
      setIsLoading(false);
    }
  };

  /* ---------- UI ---------- */

  return (
    <div className="p-4 bg-slate-200 min-h-full">
      {/* Header */}
      <div className="mb-4">
        <h1 className="text-2xl font-semibold text-gray-900">Trip Sheet</h1>
        <p className="text-sm text-gray-500 mt-1">
          Manage and view trip sheets for your logistics operations.
        </p>
      </div>

      <TripSheetForm tripSheet={tripSheet} setTripSheet={setTripSheet} />
      <div className="flex justify-end mt-3" onClick={handleSaveTripSheet}>
        <div className="px-6  py-1 rounded border border-sky-500 text-sm bg-sky-500 text-white cursor-pointer hover:bg-sky-600">
          {isLoading ? "Loading..." : "Save"}
        </div>
      </div>
    </div>
  );
};

export default TripSheet;
